import { RiskProfileStatsGrid } from '../../RiskProfileStatsGrid'
import { useProfileElementTypeData } from '../../../hooks/useProfileElementTypeData'
import { useProfileHazardTypeData } from '../../../hooks/useProfileHazardTypeData'
import type { RiskProfileQueryParams } from '../../../hooks/useRiskProfileQueryParams'
import type { RiskProfileMetricOption } from '../../../types/riskProfile.types'

interface TypeStatsSectionProps {
  queryParams: RiskProfileQueryParams | null
  metricOption: RiskProfileMetricOption
}

export function TypeStatsSection({ queryParams, metricOption }: TypeStatsSectionProps) {
  const { query: elementQuery } = useProfileElementTypeData(queryParams)
  const { query: hazardQuery } = useProfileHazardTypeData(queryParams)

  return (
    <RiskProfileStatsGrid
      elementData={elementQuery.data}
      hazardData={hazardQuery.data}
      metricOption={metricOption}
      isLoading={elementQuery.status === 'pending' || hazardQuery.status === 'pending'}
    />
  )
}
